exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container {\n    position: relative;\n    text-align: center;\n    color: white;\n}\n.centered {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    -webkit-transform: translate(-50%, -50%);\n            transform: translate(-50%, -50%);\n    color: white;\n    font-size: 40px;\n    margin-top: 100px;\n    font-family: monospace;\n    text-align: center;\n}\n.centered-btn {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    -webkit-transform: translate(-50%, -50%);\n            transform: translate(-50%, -50%);\n    color: black;\n    font-size: 15px;\n    margin-top: 150px;\n    font-family: monospace;\n    text-align: center;\n    background: rgb(255, 255, 255);\n}\n@media screen and (max-width: 1100px) {\n  .centered-btn {\n    display: none;\n  }\n  .centered {\n    display: none;\n  }\n}\nimg {\n  width: 100%;\n  height: auto;\n  max-height: 700px;\n  margin-left: auto;\n  margin-right: auto;\n\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/juliusbade/Desktop/UnderArmour-Rebuild/src/app/top-row/top-row.component.css
// module id = ../../../../../src/app/top-row/top-row.component.css
// module chunks = main